import { z } from 'zod';

/**
 * Zod schemas for tenant-related entities
 * These provide runtime validation and type inference
 */

// Tenant schema (API/Prisma: coerce name, email, status)
const tenantStatusEnum = ['Current', 'Notice', 'Past'] as const;

export const tenantSchema = z.object({
  id: z.string(),
  name: z.string().transform(n => (n?.trim() || 'Tenant')),
  unitId: z.string().nullish(),
  propertyId: z.string(),
  email: z.string().email().or(z.literal('')).transform(v => (v === '' ? 'tenant@example.com' : v)),
  phone: z.string().nullish().default(''),
  leaseStart: z.string().nullish().default(''),
  leaseEnd: z.string().nullish().default(''),
  status: z.string().transform(s => (tenantStatusEnum.includes(s as (typeof tenantStatusEnum)[number]) ? s as (typeof tenantStatusEnum)[number] : 'Current')),
  balance: z.number().nullish().default(0),
  avatar: z.string().nullish().default(''),
  hcvProgramId: z.string().nullish(),
  paymentProfile: z.string().nullish(),
  accessCode: z.string().nullish(),
  portalStatus: z.string().nullish(),
  applicationId: z.string().nullish(),
  dateOfBirth: z.string().nullish(),
  employerName: z.string().nullish(),
  employerPhone: z.string().nullish(),
  emergencyContactName: z.string().nullish(),
  emergencyContactPhone: z.string().nullish(),
  emergencyContactRelation: z.string().nullish(),
  currentAddress: z.string().nullish(),
  hasPets: z.boolean().nullish(),
  petCount: z.number().int().nonnegative().nullish(),
  petTypes: z.array(z.string()).nullish(),
  hasCoSigner: z.boolean().nullish(),
  coSignerName: z.string().nullish(),
  coSignerEmail: z.string().email().nullish().or(z.literal('')).transform(v => (v === '' ? undefined : v)),
  coSignerPhone: z.string().nullish(),
});

export type Tenant = z.infer<typeof tenantSchema>;
